import { PROFILE_RESOURCE,  CLIENT_RESOURCE} from '../api/resources';
import { fetchResource, updateResource, addResource, uploadResourceMedia} from './remote';

export const fetchProfile = fetchResource(PROFILE_RESOURCE, true);
export const updateProfile = updateResource(PROFILE_RESOURCE, null, true);


export const fetchClient = fetchResource(
	CLIENT_RESOURCE,
)

export const addDisplay_device_logo = addResource(
	CLIENT_RESOURCE, 'display_device_logo',
	{ success: 'Display Device Logo Updated Successfully', error: 'An error occured while updating display device logo' }
)

export const add_New_Logo = uploadResourceMedia(
	CLIENT_RESOURCE, 'device_logo',
	{ success: 'Device Logo Updated Successfully', error: 'An error occured while updating device logo' }
) 


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/actions/profile.js